<template>
	<div class="page-stages">
		<div class="page-stages__wrapper">
			<div class="page-stages__container">
				<div class="page-stages__header">
					<h1 class="section-title section-title--page-stages">Stages</h1>
					<div class="notification-wrap-center">
						<PartNotifications v-if="notificationsData.msg" :data="notificationsData"/>
					</div>
				</div>

				<div class="page-stages__list-wrap">
					<ol class="page-stages__list-stages">
						<li v-for="stage in stages" :key="stage.id">
							<div class="page-stages__list-stages-item">
								<div class="page-stages__list-stages-item-content">
									<span class="page-stages__list-stages-color" :style="{background: stage.color}"></span>
									<span class="page-stages__list-stages-name">{{ stage.title }}</span>
								</div>
								<div v-if="stage.type !== 'default'" class="page-stages__list-stages-buttons">
									<a class="page-stages__list-stages-edit" @click="updateStagePopup(stage.id)">
										<SvgIcon class="page-stages__list-stages-icon" iconName="ico-edit"/>
									</a>
									<!-- TODO: Commented until come on Matching -->
									<button class="page-stages__list-stages-trash" @click="showDeletePopup(stage.id)">
										<SvgIcon class="page-stages__list-stages-icon" iconName="ico-trash-border"/>
									</button>
								</div>
							</div>
						</li>
					</ol>
				</div>
				<div class="page-stages__new-stage">
					<a class="btn btn--mid btn--icon" @click="updateStagePopup">
						<SvgIcon class="btn-icon page-stages__btn-icon" iconName="ico-plus"/>
						<span>Add New</span>
					</a>
				</div>
			</div>
			<!-- New stage and edit stage poupup -->
			<transition name="fade">
				<div class="page-stages__new-stage-popup" v-if="showNewStage">
					<BlockEditStage
						@showLoader="showLoader"
						@cancelEdit="cancelEdit"
						@addedStage="addedStage"
						:data="dataNewStage"
					/>
				</div>
			</transition>
			<!-- Delete stage poupup -->
			<transition name="fade">
				<!--<PartPopupDelete
					v-on-click-outside.static="closePopupDelete"
					v-if="showPopupDelete"
					:data="PopupDelete"
					@confirmPopupDelete="confirmPopupDelete"
					@closePopupDelete="closePopupDelete"
				>
					<template v-slot:popupTitle>Are you sure you want to delete this Stage?</template>
					<template v-slot:popupCancel>No</template>
					<template v-slot:popupConfirm>Yes</template>
				</PartPopupDelete>-->
				<div class="popup__wrap popup__wrap-delete-stage" v-if="showPopupDelete">
					<transition name="fade-popup" appear>
						<div class="popup">
							<span class="popup__wrap-delete-stage-title">
								<span>Delete Stage</span>
							</span>
							<span class="popup__wrap-delete-txt">Do you want to delete the stage
								“<span class="popup__wrap-delete-stg">Lead</span>”?
							</span>
							<div class="popup__btn-stage-wrap">
								<a class="btn btn--white popup__btn-stage" href="javascript:;">
									<span>Cancel</span>
								</a>
								<a class="btn popup__btn-stage" href="javascript:;">
									<span>Delete</span>
								</a>
							</div>
						</div>
					</transition>
				</div>
			</transition>
			<!-- Delete used stage poupup -->
			<transition name="fade">
				<div class="popup__wrap popup__wrap-delete-stage" v-if="showUsedStagesDelete">
					<transition name="fade-popup" appear>
						<div class="popup">
							<span class="popup__wrap-delete-stage-title">
								<span>Delete Stage</span>
							</span>
							<span class="popup__wrap-delete-txt popup__wrap-delete-txt-used">
								The stage
								“<span class="popup__wrap-delete-stg">Lead</span>”
								is being used. If you want to delete it, <br>
								you must replace it with another stage.
							</span>
							<div class="popup__wrap-delete-stage-info">
								<span class="popup__wrap-delete-stage-info-title">Delete:</span>
								<div class="popup__wrap-delete-stage-info-stg">
									<span class="popup__wrap-delete-stage-info-color" :style="{background: stageUsed.hex}"></span>
									<span class="popup__wrap-delete-stage-info-name">{{ stageUsed.name }}</span>
								</div>
							</div>
							<div class="popup__wrap-delete-stage-replace">
								<span class="popup__wrap-delete-stage-info-title">Replace with</span>
								<div class="popup__wrap-delete-stage-replace-inputs">
									<PartCheckboxDropdown :data="DataUsedStages"/>
									<span class="popup__wrap-delete-stage-replace-sep">or</span>
									<a class="popup__wrap-delete-stage-replace-inputs-btn">
										<span>+ Add new Stage</span>
									</a>
								</div>
							</div>
							<div class="popup__btn-stage-wrap">
								<a class="btn btn--white popup__btn-stage" href="javascript:;">
									<span>Cancel</span>
								</a>
								<a class="btn popup__btn-stage popup__btn-stage--lg" href="javascript:;">
									<span>Replace and Delete</span>
								</a>
							</div>
						</div>
					</transition>
				</div>
			</transition>
		</div>
		<PartLoaderBig v-if="pageLoader"/>
	</div>
</template>
<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import PartNotifications from '@/components/parts/PartNotifications';
import BlockEditStage from '@/components/blocks/Admin/Stages/BlockEditStage';
import PartCheckboxDropdown from '@/components/parts/PartCheckboxDropdown';
// import PartPopupDelete from '@/components/parts/PartPopupDelete';
import PartLoaderBig from '@/components/parts/PartLoaderBig';
import { mixin as onClickOutside } from 'vue-on-click-outside';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data: () => {
		return {
			DataUsedStages: {
				label: '',
				placeholder: 'Select replacement stage',
				labelId: 'used-stage-label',
				inputId: 'used-stage-input',
				searchable: true,
				mandatoryFiled: false,
				options: [
					{
						id: 'lead',
						label: 'Lead',
						isNew: true
					}, {
						id: 'emailed',
						label: 'Emailed'
					}
				],
				multiple: false
			},
			stageUsed: {
				hex: '#FF9800',
				name: 'Lead'
			},
			pageLoader: false,
			showPopupDelete: false,
			showUsedStagesDelete: false,
			classScroll: 'prevent-scroll',
			dataNewStage: {
				edit: false,
				id: ''
			},
			showNewStage: false,
			notification: '',
			// PopupDelete: {
			// 	itemID: ''
			// },
			notificationsData: {
				type: '',
				msg: ''
			}
		};
	},
	components: {
		PartNotifications,
		BlockEditStage,
		// PartPopupDelete,
		PartCheckboxDropdown,
		SvgIcon,
		PartLoaderBig
	},
	created() {
		this.$store.dispatch('fetchStages');
	},
	computed: {
		stages() {
			const s = this.$store.getters.getStages;
			// s.push();
			const defaultStage = {
				additional_data: null,
				color: '#FF9800',
				color_id: '0',
				created_at: null,
				datepicker: false,
				default_date: 'day of setting the stage',
				deleted_at: null,
				id: 0,
				status: 1,
				title: 'Lead',
				type: 'default',
				updated_at: null
			};
			const defaultStageEmailed = {
				additional_data: null,
				color: '#2684ff',
				color_id: '0',
				created_at: null,
				datepicker: false,
				default_date: 'day of setting the stage',
				deleted_at: null,
				id: 0,
				status: 1,
				title: 'Emailed',
				type: 'default',
				updated_at: null
			};
			const defaultNoFollowUp = {
				additional_data: null,
				color: '#2684ff',
				color_id: '0',
				created_at: null,
				datepicker: false,
				default_date: 'day of setting the stage',
				deleted_at: null,
				id: 0,
				status: 1,
				title: 'No Follow-Up',
				type: 'default',
				updated_at: null
			};
			const defaultDissmissedSystemMatch = {
				additional_data: null,
				color: '#2684ff',
				color_id: '0',
				created_at: null,
				datepicker: false,
				default_date: 'day of setting the stage',
				deleted_at: null,
				id: 0,
				status: 1,
				title: 'Dissmissed System Match',
				type: 'default',
				updated_at: null
			};
			if (s.length && s.find(st => st.id === 0)) {
				s.unshift(defaultStage);
				s.unshift(defaultStageEmailed);
				s.unshift(defaultNoFollowUp);
				s.unshift(defaultDissmissedSystemMatch);
			}
			return s;
		}
	},
	mixins: [onClickOutside],
	methods: {
		showLoader() {
			this.pageLoader = true;
		},
		showDeletePopup(id) {
			this.showPopupDelete = true;
			this.PopupDelete.itemID = id;
			this.$parent.$refs.app.parentNode.classList.add(this.classScroll);
		},
		closePopupDelete() {
			this.closeModal();
		},
		confirmPopupDelete(id) {
			this.deleteStage(id);
			this.showPopupDelete = false;
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
		},
		addedStage() {
			this.closeModal();
			this.$store.dispatch('fetchStages');
			this.pageLoader = false;
		},
		cancelEdit() {
			this.closeModal();
		},
		closeModal() {
			this.showNewStage = false;
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
		},
		updateStagePopup(id) {
			if (!isNaN(id)) {
				this.dataNewStage.edit = true;
				this.dataNewStage.id = id;
			} else {
				this.dataNewStage.edit = false;
			}
			this.showNewStage = true;
			this.$parent.$refs.app.parentNode.classList.add(this.classScroll);
		},
		deleteStage(id) {
			this.$store.dispatch('deleteStage', id).then(response => {
				this.$store.dispatch('fetchStages');
				if (undefined !== response.data) {
					this.notification = response.data.message;
				}
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.page-stages {
	padding-top: 43px;
    padding-left: 3px;
	padding-bottom: 40px;

	@include mq($xl) {
		padding-left: 0;
		padding-top: 20px;
		padding-bottom: 20px;
	}
}

.section-title--page-stages {
	margin-bottom: 40px;

	@include mq($lg) {
		margin-bottom: 20px;
	}
}

.page-stages__header {
	position: relative;
}

.page-stages__wrapper {
	padding: 0 15px;

	@include mq($xl) {
		padding: 0;
	}
}

/*--------------------------------------------------------------
## Status list
--------------------------------------------------------------*/
.page-stages__list-wrap {
	width: fit-content;
	margin-bottom: 40px;

	@include mq($xl) {
		margin-bottom: 20px;
	}

	@include mq(640px) {
		max-width: 100%;
		width: 100%;
	}
}
/*.page-stages__list-stages {
	li {
		list-style: decimal;
		padding-left: 12px;

		@include mq($sm) {
			padding-left: 5px;
		}
	}
}*/

.page-stages__list-stages {
  list-style: none;
  counter-reset: number-counter;

	@include mq(640px) {
		max-width: 360px;
	}
}

.page-stages__list-stages li {
	counter-increment: number-counter;
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}

.page-stages__list-stages li::before {
	content: counter(number-counter) ". ";
	font-family: Fira Sans;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 20px;
	display: flex;
	color: $fiord;
	min-width: 35px;

	@include mq($sm) {
		padding-right: 10px;
	}
}

body {
  font-family: Montserrat, sans-serif;
}

.page-stages__list-stages-item {
	display: flex;
    align-items: initial;
    justify-content: space-between;
	font-family: $font-main;
	font-size: 14px;
	line-height: 1.2;
	color: $fiord;
	width: 100%;
}

.page-stages__list-stages-item-content {
	display: flex;
	min-width: 260px;
	position: relative;
	padding-left: 28px;
	padding-right: 20px;
	align-items: center;

	@include mq($xl) {
		padding-left: 20px;
	}

	@include mq(640px) {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		max-width: 75%;
		min-width: auto;
	}
}

.page-stages__list-stages-color {
	width: 16px;
	height: 16px;
	display: flex;
	align-items: center;
	border-radius: 50%;
	position: absolute;
	top: 46%;
	transform: translateY(-50%);
	left: 0;
}

.page-stages__list-stages-name {
	font-family: $font-main;
	font-size: 16px;
	line-height: 20px;
	display: block;
	color: $fiord;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.page-stages__list-stages-trash,
.page-stages__list-stages-edit {
	border: none;
	background-color: transparent;
	transition: $dur $ease;
	font-size: 18px;
	cursor: pointer;

	@include hover {
		color: $dodger-blue;
	}
}

.page-stages__list-stages-trash{
	color: $red;
}

.page-stages__list-stages-edit  {
	padding-right: 20px;
	color: $dodger-blue;

	@include hover {
		color: $fiord;
	}

	@include mq($xl) {
		padding-right: 15px;
	}

	@include mq($lg) {
		padding-right: 10px;
	}

	@include mq($md) {
		padding-right: 5px;
	}

	@include hover {
		color: $fiord;
	}
}

.page-stages__list-stages-icon {
	display: inline-block;
    padding-right: 7px;

	@include mq($xl) {
		padding-right: 0;
	}
}

.page-stages__new-stage {
	.page-stages__btn-icon {
		margin-right: 9px;
	}
}

/*--------------------------------------------------------------
## Popup
--------------------------------------------------------------*/
.page-stages__new-stage-popup {
	position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/*--------------------------------------------------------------
## Popup delete stages
--------------------------------------------------------------*/
.popup__wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba($slate-gray, .5);
}
.popup {
    max-width: 475px;
    padding: 23px;
    width: 100%;
    background-color: $white;
    display: flex;
    flex-direction: column;
    justify-content: center;
	text-align: left;
    box-shadow: 0 2px 4px rgba($black, .25);
    border-radius: 8px;

    @include mq($lg) {
        padding: 40px 30px;
    }

    @include mq($sm) {
        padding: 40px 15px;
    }
}

.popup__title {
    margin-bottom: 25px;
    font-size: 20px;
    text-align: center;

    @include mq($lg) {
        font-size: 18px;
        margin-bottom: 20px;
    }

    @include mq($md) {
        font-size: 16px;
    }

    @include mq($sm) {
        font-size: 15px;
    }
}

.popup__btn-stage-wrap {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    max-width: 100%;
    width: 100%;
}

.popup__btn-stage {
	min-width: 96px;
	max-width: 96px;

	&:not(:first-of-type) {
		margin-left: 15px;
	}

	&.popup__btn-stage--lg {
		min-width: 158px;
		max-width: 158px;
	}
}

.popup__wrap-delete-txt {
	display: block;
	font-family: $font-main;
	font-size: 16px;
	line-height: 1.2;
	color: $shuttle-gray;
	margin-bottom: 30px;

	@include mq($xl) {
		br {
			display: none;
		}
	}

	@include mq($lg) {
		margin-bottom: 15px;
	}

	@include mq($sm) {
		font-size: 14px;
	}

	&.popup__wrap-delete-txt-used {
		margin-bottom: 33px;

		@include mq($lg) {
			margin-bottom: 15px;
		}
	}
}

.popup__wrap-delete-stg {
	font-weight: bold;
}

.popup__wrap-delete-stage-title {
	font-family: $font-second;
	font-weight: 500;
	font-size: 20px;
	line-height: 23px;
	color: $fiord;
	margin-bottom: 22px;
}

.popup__wrap-delete-stage-info {
	display: flex;
    align-items: center;
	margin-bottom: 20px;
}

.popup__wrap-delete-stage-info-title {
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	color: $slate-gray;
}

.popup__wrap-delete-stage-info-stg {
	position: relative;
	display: flex;
    align-items: center;
}

.popup__wrap-delete-stage-info-color {
	width: 16px;
	height: 16px;
	display: flex;
	align-items: center;
	border-radius: 50%;
	margin: 0 5px 0 12px;
}

.popup__wrap-delete-stage-info-name {
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	display: block;
	color: $fiord;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.popup__wrap-delete-stage-replace-inputs {
	display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
	margin-bottom: 30px;

	@include mq($lg) {
		margin-bottom: 15px;
	}

	@include mq($sm) {
		flex-direction: column;
	}
}

.popup__wrap-delete-stage-replace-sep {
	font-size: 14px;
	color: $fiord;
	display: block;

	@include mq($sm) {
		margin-bottom: 10px;
	}
}

.popup__wrap-delete-stage-replace-inputs-btn {
	font-family: $font-main;
	font-size: 16px;
	line-height: 20px;
	color: $dodger-blue;
	word-spacing: -1px;
    letter-spacing: 0.3px;
}

.popup__wrap-delete-stage  {
	.popup {
		padding: 23px 26px 35px 23px;

		@include mq($lg) {
			padding: 23px;
		}
	}
}
</style>
